<template>
  <main class="main inventory-page">
    <div class="container">
      <UiBreadCrumbsV2
        :items="[{ title: $t('inventory.title'), link: localePath('/inventory') }]"
      />

      <PagesInventorySteamIdChecker />

      <div class="main-wrapper">
        <div class="w-100">
          <PagesInventoryTopList
            ref="topList"
            is-top
          />

          <section
            v-if="false"
            class="inventories-section"
          >
            <i18n-t
              keypath="inventory.top_banned_inventory"
              tag="h2"
            >
              <template #banned>
                <span class="red">{{ $t("inventory.top_banned_inventory_span") }}</span>
              </template>
            </i18n-t>

            <PagesInventoryInventoriesList is-banned />
          </section>
          <section
            v-if="data?.data?.inventoryRarestItems?.length"
            class="items-section"
          >
            <i18n-t
              keypath="inventory.rarest_items"
              tag="h2"
            />
            <LazyPagesInventoryItemsList
              :items="data?.data?.inventoryRarestItems as InventoryRarePopularItem[]"
            />
          </section>
          <section
            v-if="data?.data?.inventoryMostPopularItems?.length"
            class="items-section"
          >
            <i18n-t
              keypath="inventory.most_popular_items"
              tag="h2"
            />
            <LazyPagesInventoryItemsList
              :items="data?.data?.inventoryMostPopularItems as InventoryRarePopularItem[]"
            />
          </section>
          <PagesMarketComponentsQuestionsHub
            :items="faqItems"
          />
        </div>

        <PagesInventoryRecentInventories
          :market="topList?.market?.market_name"
        />
      </div>
    </div>
  </main>
</template>

<script lang="ts" setup>
import type { InventoryRarePopularItem } from '~/graphql/generated/schema-types';

const localePath = useLocalePath();
const topList = ref(null);

const { data } = await useAsyncData(
  'getInventoryInit',
  getInventoryInit,
);

const { locale, t, tm, rt } = useI18n();

const faqI18n = computed(() => {
  return (tm('inventory_faq') || []);
});
const faqItems = computed(() => {
  return ((faqI18n.value || []) as any[])?.map((item) => {
    return {
      name: rt(item.question),
      value: rt(item.answer)?.replace(/\n/g, '<br>'),
    };
  });
});

const title = computed(() => {
  return t('inventory.seo.main.title');
});
const description = computed(() => {
  return t('inventory.seo.main.desc');
});
// const weaponIcon = 'https://csmarketcap.com/img/logo-bg-black.png';
const { alternateLinks, canonical } = useAlternateLinks(`/inventory`);

useHead({
  title: () => title.value,
  meta: [
    {
      name: 'keywords',
      content:
          'steam, counter strike global offensive, csgo, cs2, skins, items, inventory',
    },
  ],
  link: () => alternateLinks.value,
});

useSeoMeta({
  title: () => title.value,
  ogTitle: () => title.value,
  description: () => description.value,
  ogDescription: () => description.value,
  // ogImage: () => weaponIcon,
  twitterCard: 'summary_large_image',
  twitterTitle: () => title.value,
  twitterDescription: () => description.value,
  // twitterImage: () => weaponIcon,
  ogSiteName: 'CSMarketCap',
  ogUrl: () => canonical.value,
  ogType: 'website',
  ogLocale: () => locale.value,
});

useSchemaOrg([
  defineBreadcrumb({
    itemListElement: [
      { name: t('main'), item: '/' },
      {
        name: title,
        item: localePath('/inventory'),
      },
    ],
  }),
  {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    'mainEntity': faqItems.value.map(item => ({
      '@type': 'Question',
      'name': item.name,
      'acceptedAnswer': {
        '@type': 'Answer',
        'text': item.value,
      },
    })),
  },
]);
</script>

<style lang="scss" scoped>
.inventory-page {
  padding: 18rem 0 4rem;
  font-size: 16px;
  color: var(--surfaces-on-surface-variable);

  section {
    margin-bottom: 40px;

    h2 {
      font-size: 18px;
      font-weight: 800;
      margin-bottom: 24px;
      color: var(--surfaces-on-surface);
    }
  }

  .main-wrapper {
    display: flex;
    gap: 32px;
    justify-content: space-between;
    align-items: flex-start;
  }

  &:deep(.questions-hub) .body-title {
    font-size: 18px;
    font-weight: 800;
    margin-bottom: 24px;
    color: var(--surfaces-on-surface);

  }
}

@media screen and (max-width: 1115px) {
  .inventory-page {
    padding-top: 7.5rem;
  }
}

@media screen and (max-width: 989px) {
  .inventory-page {
    .main-wrapper {
      flex-direction: column;
      gap: 16px;
    }

    section {
      margin-bottom: 24px;
    }
  }
}
</style>
